import AsyncStorage from "@react-native-async-storage/async-storage";
import { Smooch } from 'react-native-smooch'
import { Platform } from "react-native";
import { clientConfigPath } from "../../config/Constant";

// Holds the in-flight login promise so handleOpenChat can await it if the
// user taps chat before the background login has finished.
let _loginPromise = null;
export const getAlliantsChatLoginPromise = () => _loginPromise;

/**
 * Called in the background at app login.
 * Authenticates the Smooch SDK.
 * Fails silently — chat will open in anonymous mode if this errors.
 */
export const loginAlliantsChat = () => async (_dispatch, getState) => {
  _loginPromise = (async () => {
    try {
      const state = getState();
      const { loggedInRoomNumber, clientId, fcmToken } = state.appConfigSlice;
      const { currentGuestDetails } = state.guestDetailsSlice;

      const sessionToken = await AsyncStorage.getItem("sessionToken");


      if(!Smooch){
        return false;
      }

      const guest = {
        externalId: currentGuestDetails?.guestProfile?.pmsProfileId,
        phoneNumber: currentGuestDetails?.guestProfile?.phoneNumber,
        firstName: currentGuestDetails?.guestProfile?.firstName,
        lastName: currentGuestDetails?.guestProfile?.lastName,
        email: currentGuestDetails?.guestProfile?.email,
        reservationNumber: currentGuestDetails?.reservationNumber,
        room: loggedInRoomNumber,
      };

      const res = await clientConfigPath.post("/alliantsChat/getDetails", {
        header: { sessionToken },
        payload: { os: Platform.OS, guest },
      });

      console.log("Alliants chat session response:", res?.data);

      if (res?.data?.header?.status?.code !== "SUCCESS") {
        console.log("Alliants: non-SUCCESS response — chat will open anonymously", res?.data?.header?.status?.msg);
        return false;
      }

      const chatData = res.data?.payload;
      if (!chatData?.appUserUserId || !chatData?.tabletToken) {
        console.log("Alliants: missing appUserUserId/tabletToken — chat will open anonymously");
        return false;
      }

      const { tabletToken, appUserUserId, profileId, smoochChannelId, location } = chatData;

      // Always logout first to clear any existing session
      try { await Smooch.logout(); } catch (error) {console.log("Alliants: smooch logout failed",error);}

      await Smooch.login(appUserUserId, tabletToken);

      if (guest.firstName) Smooch.setFirstName(guest.firstName);
      if (guest.lastName) Smooch.setLastName(guest.lastName);
      if (guest.email) Smooch.setEmail(guest.email);

      Smooch.setMetadata({
        room: guest.room,
        reservation_number: guest.reservationNumber,
        short_property_code: location?.shortPropertyCode,
        property_code: location?.shortPropertyCode,
        location_display_name: location?.displayName,
      });

      // Android push notifications use FCM; iOS uses APNs (handled natively)
      if (Platform.OS === "android" && fcmToken) {
        Smooch.setFirebaseCloudMessagingToken(fcmToken);
      }

      console.log(`Alliants: login successful — appUserUserId sent: ${appUserUserId}`);
      return true;
    } catch (error) {
      // Silent fail — chat will open in anonymous mode
      console.log("Alliants: background login failed", error?.message);
      return false;
    } finally {
      _loginPromise = null;
    }
  })();

  return await _loginPromise;
};

/**
 * Sets the FCM token on the Smooch SDK for Android push notifications.
 * Called whenever the FCM token becomes available, even in anonymous mode,
 * so push notifications work without a Smooch.login() call.
 */
export const setAlliantsAndroidFcmToken = (fcmToken) => {
  if (Platform.OS === "android" && fcmToken) {
    try {
      Smooch?.setFirebaseCloudMessagingToken(fcmToken);
    } catch (error) {
      console.log("Alliants: failed to set FCM token", error?.message);
    }
  }
};


/**
 * Called on logout to clear the Smooch session.
 */
export const logoutAlliantsChat = () => async () => {

  if(!Smooch){
    return;
  }

  try { Smooch.setFirstName(''); } catch (_) {}
  try { Smooch.setLastName(''); } catch (_) {}
  try { Smooch.setEmail(''); } catch (_) {}
  try { Smooch.setMetadata({}); } catch (_) {}

  try {
    try { Smooch.close(); } catch (_) {}
    await Smooch.logout();
    console.log("Alliants: logged out");
  } catch (error) {
    console.log("Alliants: logout error", error?.message);
  }
};
